import { Schema as SurfaceParamsSchema } from 'App/Surfaces/schema';

import { Surface } from 'core/types/surface';

import usePaginationHandler from './usePaginationHandler';

export default function useSurfaces(params: SurfaceParamsSchema) {
  return usePaginationHandler<Surface>('surfaces', params);
}
